<template>
  <v-container class="video none-fluid link">
    <banner>Videos</banner>
    <v-tabs color="rgb(153, 27, 30)" class="custom-tabs" background-color="transparent" right>
      <v-tab @click="selected = 'youtube'">YOUTUBE</v-tab>
      <v-tab @click="selected = 'movies'">NON-YOUTUBE</v-tab>
    </v-tabs>
    <br />
    <div class="video-content mx-auto">
      <div v-if="selected === 'youtube'">
        <v-row justify="space-between">
          <v-col v-for="(video,i) in youtube" :key="i" cols="12" lg="6">
            <div v-html="video.video"></div>
            <h4>{{ video.title }}</h4>
            <p v-html="$sanitize(video.intro)"></p>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-expansion-panels multiple v-model="panels">
          <v-expansion-panel
            v-for="(section,i) in movies"
            :key="i"
            expand
          >
            <v-expansion-panel-header class="expansion-header">{{
              section.title
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="expansion-content">
              <div
                v-for="(video,i) in section.videos"
                :key="i"
                v-html="$sanitize(video)"
                class="expansion-subsection"
              ></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getAllMovies, getAllYoutube } from "../../service/media/video";
import Banner from "../global/Banner";

export default {
  data() {
    return {
      selected: "youtube",
      panels: [],
      youtube: [],
      movies: [],
    };
  },
  mounted() {
    // get all movies
    getAllMovies()
      .then((movies) => {
        this.movies = movies;
        for (let i = 0; i < movies.length; ++i) {
          this.panels.push(i);
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
    // get all youtube videos
    getAllYoutube()
      .then((youtube) => {
        this.youtube = youtube;
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  components: {
    Banner,
  },
};
</script>

<style lang="scss">
.video {
  h4 {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  iframe {
    width: 100%;
    height: 260px;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
  .video {
    h4 {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    iframe {
      width: 100%;
      height: 260px;
    }
  }
}
</style>
